import React, { useState, useEffect } from "react";
import { getAPIURL, getUserID } from "../../services/helper";
import http from "../../services/http";
import ReportHeader from "./components/Header";
import ReportFooter from "./components/Footer";
import ReportBody from "./components/Body";
import ReportPrintHeader from "./components/ReportPrintHeader";
import ReportPrintTable from "./components/ReportPrintTable"; // ✅ new
import { Link } from "react-router-dom";
import { Spinner } from "reactstrap";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { openViewWithParams, openView } from "../../ReduxToolkit/Reducers/viewReducer";

const CloseReports = ({ isPrint = false }) => {
  const api_url = getAPIURL();
  const biller_id = getUserID();
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchCloseReports();
  }, []);

  useEffect(() => {
    if (isPrint && !loading) {
      setTimeout(() => window.print(), 500);
    }
  }, [isPrint, loading]);

  const fetchCloseReports = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(`${api_url}/reports/close/${biller_id}`);
      setData(data.sort((a, b) => new Date(b.closed_at) - new Date(a.closed_at)));
    } catch (error) {
      console.error("Error fetching close reports:", error);
    }
    setLoading(false);
  };

  // Column definition
  const baseColumns = [
    {
      name: "Register ID",
      selector: (row) => row.register_id,
    },
    { name: "User", selector: (row) => row.cashier },
    { name: "Opened At", selector: (row) => row.opened_at },
    { name: "Closed At", selector: (row) => row.closed_at },
    { name: "Total Sales", selector: (row) => row.total_sales },
    { name: "Total Amount", selector: (row) => row.total_amount },
    {
      name: "Refund",
      cell: (row) => (
        <span style={{ color: row.refund_amount > 0 ? "red" : "inherit" }}>
          {row.refund_amount > 0 ? `$${parseFloat(row.refund_amount).toFixed(2)}` : "-"}
        </span>
      ),
    },
  ];

  const columns = [...baseColumns];

  if (!isPrint) {
    columns.push({
      name: "Actions",
      cell: (row) => (
        <Link
          onClick={() =>
            dispatch(
              openViewWithParams({
                view: "close_register_summary",
                params: { register_id: row.register_id, backTo: "reports_close" },
              })
            )
          }
          className="btn btn-primary btn-sm"
          title="View Report"
        >
          <FaExternalLinkAlt />
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    });
  }

  return (
    <div className="page-body">
      {loading ? (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          <p className="mt-3">Loading Close Reports...</p>
        </div>
      ) : (
        <>
          {isPrint ? (
            <>
              <ReportPrintHeader title="Close Reports" />
              <ReportPrintTable columns={baseColumns} data={data} />
            </>
          ) : (
            <>
              <ReportHeader
                type={"close"}
                title="Close Reports"
                dateRange={dateRange}
                setDateRange={setDateRange}
                onGenerate={fetchCloseReports}
              />
              <ReportBody columns={columns} data={data} />
              <ReportFooter link={"/print/reports/close"} />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default CloseReports;
